<template>
    <div>
        <h1>Leistungen</h1>
<!--        <ReportFetcher></ReportFetcher>-->
        <ServiceTable query=""></ServiceTable>
    </div>
</template>

<script>

    import ServiceTable from "../components/ServiceTable";
    export default {
        name: "Services",
        components: {ServiceTable},
        data() {
            return {
            }
        },
        created() {
          document.title = "Leistungen";
        }

    }
</script>

<style scoped>

</style>